import type { RouteObject } from 'react-router-dom';

import { StubPage } from '@/app/pages/StubPage';
import { defineHandle } from '@/app/routes/types';

import { supportAccessRoles } from './access';

export const supportRoutes: RouteObject[] = [
  {
    path: 'support',
    element: <StubPage titleKey="nav.support" dataPage="support/index" />,
    handle: defineHandle({
      roles: [...supportAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.support',
    }),
  },
];
